/** Display order: what we know, then what we are waiting on, then what we exclude. */
export var COVERAGE_KINDS = ['bound', 'awaitingNk', 'outOfModel', 'unbound'];
export var coverageOf = function (entry) {
    var _a;
    if (entry.binds && entry.binds.length > 0)
        return 'bound';
    var state = (_a = entry.semanticStatus) === null || _a === void 0 ? void 0 : _a.state;
    if (state === 'outOfSemanticModel')
        return 'outOfModel';
    if (state)
        return 'awaitingNk';
    return 'unbound';
};
export var coverageColor = function (kind) {
    if (kind === 'bound')
        return '#128000';
    if (kind === 'awaitingNk')
        return '#b06000';
    if (kind === 'outOfModel')
        return '#7a4fa3';
    return '#5a6b7d';
};
